import {PropertyTypeEnum} from 'module/Properties/enum/PropertyTypeEnum'

export function genCompositeId(object: string, attribute: string, type: PropertyTypeEnum = PropertyTypeEnum.UserProperty, subkrit: string | null = null) {
	return `${object}_${attribute}_${type}` + (type === PropertyTypeEnum.Paramdiv ? '_' + subkrit : '')
}

export function propDefaultTrue(p: null | undefined | string) {
	return p !== 'N'
}

export function propDefaultFalse(p: null | undefined | string) {
	return p === 'J'
}

export function propDefault1(p: null | undefined | string) {
	const num = Number(p)
	if (!p || isNaN(num)) return 1
	return num
}

export function propDefaultTrueUserlevelGE(p: null | undefined | string, userlevel: number) {
	const ul = Number(p)
	if (isNaN(ul)) {
		return p !== 'N'
	} else {
		return userlevel >= ul
	}
}
